import environment from '@environments/environment';
import { TalkdeskChatSDK } from '../types/talkdesk.type';
import { User } from '@iris-sites/interfaces/sites.interfaces';

export function initializeTalkdeskScript(user: User): void {
  try {
    // Check if script is already loaded
    if (window.TalkdeskChatSDK || !user?.id) {
      return;
    }
    // Create container div
    const divContainer = document.createElement('div');
    divContainer.id = 'tdWebchat';
    document.body.appendChild(divContainer);

    // Create script element
    const script = document.createElement('script');
    const firstScriptTag = document.getElementsByTagName('script')[0];
    script.type = 'text/javascript';
    script.charset = 'UTF-8';
    script.id = 'tdwebchatscript';
    script.src = environment.talkdesk.scriptUrl;
    script.async = true;

    // Handle script loading errors
    script.onerror = function () {
      throw new Error('Failed to load Talkdesk Chat SDK script');
    };

    // Add script to DOM
    if (firstScriptTag && firstScriptTag.parentNode) {
      firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
    } else {
      document.head.appendChild(script);
    }

    // Set up onload handler
    script.onload = function () {
      if (!window.TalkdeskChatSDK) {
        throw new Error('TalkdeskChatSDK not found after script loaded');
      }

      try {
        const webchat = (window.TalkdeskChatSDK as TalkdeskChatSDK)(
          'tdWebchat',
          {
            touchpointId: environment.talkdesk.touchpointId,
            accountId: environment.talkdesk.accountId,
            region: environment.talkdesk.region,
          },
        );

        if (!webchat) {
          throw new Error('Failed to initialize Talkdesk Chat SDK');
        }

        webchat.init(environment.talkdesk.config);

        const fullName =
          user?.first_name && user?.last_name
            ? `${user?.first_name} ${user?.last_name}`
            : user?.first_name || user?.last_name || '';

        webchat.setCustomFieldDefaultValues({
          field_name1: fullName,
        });
        webchat.setCustomFieldDefaultValues({
          field_email1: user?.email ?? '',
        });

        webchat.setCustomFieldDefaultValues({
          chatTitle: 'Live Chat',
        });
        // Store webchat in window for potential later use
        window.webchat = webchat;
      } catch (initError) {
        throw new Error(`Error initializing Talkdesk Chat: ${initError}`);
      }
    };
  } catch (error) {
    throw new Error(`Error initializing Talkdesk script: ${error}`);
  }
}
